import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { BecomeVisibleElementsDirective } from '@fi-shared/fi-directives/become-visible/become-visible-elements.directive';
import { ReplaySubject } from 'rxjs';

@Directive({
    selector: '[fiBecomeVisibleElement]',
    exportAs: 'fiBecomeVisibleElement',
    standalone: false,
})
export class BecomeVisibleElementDirective implements AfterViewInit, OnDestroy {
    @Input('fiBecomeVisibleElement') becomeVisibleElementsDirective: BecomeVisibleElementsDirective;

    _isVisible$ = new ReplaySubject<boolean>(1);
    get isVisible$() {
        return this._isVisible$.asObservable();
    }

    constructor(private elementRef: ElementRef<HTMLElement>) {}

    ngAfterViewInit(): void {
        this.becomeVisibleElementsDirective.addElementToCheckVisibilityQueue(this.elementRef.nativeElement, () =>
            this._isVisible$.next(true),
        );
    }

    ngOnDestroy(): void {
        this.becomeVisibleElementsDirective.removeElementFromCheckVisibilityQueue(this.elementRef.nativeElement);
    }
}
